import React, {useState, useEffect } from "react";
import { Box, Button,  Divider,  Paper,  Tab,  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Tooltip} from "@mui/material";
import MyLabel from "../../../components/myLabel";
import MyButton from "../../../components/myButton";
import Modal from '@mui/material/Modal';
import Styles from "../../localTarefa/localTarefaFormulario/style";
import DeleteIcon from '@mui/icons-material/Delete';
import MySearchOptions from "../../../components/mySearchOptions";

const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {
            value === index ?
                children
            :   
                <></>
        }
      </div>
    );
  }
  
const a11yProps = (index)  =>{
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
}

const TabArea = ({label, registros, registrosSelecionadas, styles, maximoSelecionados}) => {

    const handlerRemove = (id, resposta) => {
            let _permi = registrosSelecionadas?.value.filter(item => item.id !== id || (item.id === id && item.resposta !== resposta ))
            registrosSelecionadas.set(_permi)
    }

    const onSelect = (select)=>{

        const filtro = (item) => {
            if (select.tipo_resposta === 2) {
                const opcoes = JSON.parse(select.templatelista_opcoes)
                return registrosSelecionadas?.value.filter((e => e.descricao === select.descricao))?.length >= opcoes.length && item.descricao === select.descricao


            } else {
                return item.descricao === select.descricao
            }
        }

        if (registrosSelecionadas?.value.filter(filtro)?.length <= 0) {
            registrosSelecionadas.set([...registrosSelecionadas?.value, select])

        }
    }

    return (
        <Box sx={{marginTop:'10px'}}>
            <MySearchOptions 
                getOptions = {()=>{console.log('buscando')}}

                label={label}
                values={registros?.value}
                valuesSelects={registrosSelecionadas?.value}
                onSelect={onSelect}
                maximoSelecionados = {maximoSelecionados}
                />
                <Box sx={{marginTop: '10px'}}>

                <Divider />
                </Box>
            <Box sx={{marginTop: '10px'}}>
                <Box >
                    <MyLabel sx={styles.subtitle} text={`Adicionado(s)`} component={null}  onClick={null} variant={null}/>
                </Box>
                <Box>
                    <TableContainer component={Paper} sx={{maxHeight:'25vh'}}>
                        <Table size="small"  sx={{ minWidth: 700 }} aria-label="simple table">
                            <TableHead >
                            <TableRow>
                                <TableCell sx={{...styles.tableHead, width:'60%'}}> Pergunta</TableCell>
                                <TableCell sx={{...styles.tableHead, width:'30%'}}> Resposta</TableCell>
                                <TableCell sx={{...styles.tableHead, width:'10%'}}></TableCell>                                
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {registrosSelecionadas?.value?.sort(
                                (a, b) => a.descricao.toLowerCase() < b.descricao.toLowerCase() ? -1 : 1
                            ).map((row, key) => (
                                <TableRow
                                    
                                    key={key}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                <TableCell component="th" scope="row" >
                                    {row.descricao}
                                </TableCell>
                                <TableCell component="th" scope="row" >
                                    {row.resposta}
                                </TableCell>
                                <TableCell sx={{width:'20px'}} component="th" scope="row" >
                                    <Tooltip title="Remover" placement="bottom" arrow>
                                        <Button sx={{height:'20px'}} color='error'  onClick={()=>handlerRemove(row.id, row.resposta)}><DeleteIcon /></Button>
                                    </Tooltip> 
                                </TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </Box>
    )
}


const ModalConfiguraPergunta = ({open, template, templatePerguntas, handleClose, handlerSalvar}) => {
    
    const [perguntaSelecionada, setPerguntaSelecionada] = useState([]);
    const [listagemPergunta, setListagemPergunta] = useState([]);    // lista de perguntas que vai para a seleção pergunta
    const [activeTab, setActiveTab] = useState(0);    
    
    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };       
    
    //filtra lista de perguntas
    let listaPerguntas = templatePerguntas?.value.filter(item => item.id !== template?.value.id && [1,2].includes(item.tipo_resposta));
    
    useEffect(()=>{
        setListagemPergunta(listaPerguntas.map(item=>{return {...item, name: item.descricao}}))
    },[open])
        
    useEffect(()=>{
            let _pergunta = {...template.value }
            let condicao_visivel = []
            perguntaSelecionada.map(pergunta=>{
                condicao_visivel.push({"id": pergunta.id,"resposta": 
                    //pergunta.resposta === 'Sim' ? "true" :"false"
                pergunta.resposta === 'Sim' ? "true"  : 
                pergunta.resposta === 'Não' ? "false" : 
                pergunta.resposta                
                })
            })
            _pergunta.condicao_visivel = JSON.stringify(condicao_visivel) 
            template.set(_pergunta) 

        }, [perguntaSelecionada])  

    

        /* para atualizar no postgresql
        UPDATE sua_tabela SET condicao_visivel = CONCAT('[', condicao_visivel, ']') 
        WHERE condicao_visivel NOT LIKE '[%' AND terra NOT LIKE '%]'
        */

    useEffect(()=>{

        if (open && template?.value.condicao_visivel && template?.value.condicao_visivel !== ''){
            let condi = JSON.parse(template?.value.condicao_visivel)

            let selecionadas = []
            condi.forEach(item=>{
                const _perguntaSelecionada = listaPerguntas.filter(item2 => item2.id === item.id)[0];
                selecionadas.push({..._perguntaSelecionada, 
                    
                    //resposta: item.resposta === 'true' ? "Sim" :"Não"
                resposta: item.resposta === 'true'
                    ? "Sim"
                    : item.resposta === 'false'
                        ? "Não"
                        : item.resposta
                
                })

            })
            setPerguntaSelecionada(selecionadas)
        }
        else {
            setPerguntaSelecionada([])
        }
            
    }, [open])    

    let minhasTabs = [
        {
            label:'Perguntas',  
            registros: {set: setListagemPergunta, value:listagemPergunta}, 
            registrosSelecionadas: {set: setPerguntaSelecionada, value:perguntaSelecionada}, 
            maximoSelecionados:10
        },
    ] 

    return (
        <Modal
            open= {open}
            //open={open && template.value !== null}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            
            <Box sx={ {       
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '60%',
                height: '80%',
                bgcolor: 'background.paper',
                border: '2px solid #000',
                boxShadow: 24,
                borderRadius:2,
                p: 4,}
                }>
                    <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                        <MyLabel sx={{ fontSize: "16pt", fontWeight: 600, color:'#000'}} 
                                component='h2' 
                                text='Exibe a pergunta com base na resposta de outra pergunta.'
                                />
                        <Button onClick={handleClose}>X</Button>
                    </Box>
                    <Divider />
                    <Box sx={{display:'flex', flexDirection:'column', height:'95%', justifyContent:'space-between'}}>
                        <Box sx={{marginTop:'20px'}}>
                            <Box >
                                <MyLabel sx={{ fontSize: "15pt", fontWeight: 600, color:'#000'}} 
                                        component='h2' 
                                        text={`Pergunta: ${template?.value.descricao}`}
                                        />
                            </Box>
                            <Box sx={{display:'flex', marginTop: 2 , justifyContent:'space-between'}}>
                                <Box  sx={{width:'100%', marginRight:'30px'}}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <Tabs value={activeTab} onChange={handleChange} aria-label="basic tabs example">
                                            {
                                                minhasTabs.map((item, key) => <Tab key={key} label={item.label} {...a11yProps(key)} />)
                                            }
                                        </Tabs>
                                    </Box>
                                        {
                                            minhasTabs.map((item, key)=>{
                                                return (
                                                    <CustomTabPanel key={key} value={activeTab} index={key}>
                                                        <TabArea 
                                                            label={item.label}
                                                            registros={item.registros}
                                                            registrosSelecionadas={item.registrosSelecionadas}
                                                            styles={Styles}
                                                            maximoSelecionados={item.maximoSelecionados}
                                                        />
                                                    </CustomTabPanel>
                                                )
                                            })
                                        }
                                </Box>
                            </Box>
                        
                        </Box>

                        <Box sx={{flex:'flex', flexDirection:'row', marginTop:'30px'}}>
                            <MyButton  sx={{marginRight:'20px'}} onClick={handleClose} variant='contained' text='Cancelar' color='warning'/>

                            <MyButton onClick={handlerSalvar} variant='contained' text='Salvar' color='primary'/>
                        </Box>
                    </Box>

            </Box>
        </Modal> 
    )
}

export default ModalConfiguraPergunta